import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={FlyoutProductCreationFaqSection.PRODUCT_DETAILS_ALLOW_LIST}
        question="What are allowlisted AWS accounts? Do I need to add them?"
      />
    ),
    answer: (
      <div>
        New AWS Marketplace listings start with{' '}
        <strong>limited visibility</strong>. You can allow specific AWS accounts
        to access your listing before it becomes public. This is optional.
      </div>
    ),
  },
]

interface FlyoutProductDetailsAllowlistedAccountsFaqsProps {
  indexModal?: number
  setIndexModal?: (index: number) => void
}

export const FlyoutProductDetailsAllowlistedAccountsFaqs: React.FC<
  FlyoutProductDetailsAllowlistedAccountsFaqsProps
> = () => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Allowlisted AWS Accounts"
    faqItems={faqItems}
  />
)
